<form autocomplete="off" [formGroup]="innerForm">
    <div class="float-left smart-tag-form-container container" *ngIf="smartTagModel !== null">
        <ng-template [ngIf]="schemaShouldShowComplexForm">
            <div class="row">
                <div class="col-md-10">
                    <div class="custom-control custom-checkbox">
                        <input name="isGarageBeenConverted" formControlName="isGarageBeenConverted"
                               type="checkbox"
                               class="custom-control-input"
                               id="isGarageBeenConverted">
                        <label class="custom-control-label" for="isGarageBeenConverted">Has the garage been converted to living space?</label>
                    </div>
                </div>
            </div>
        </ng-template>
        <div class="row">
            <div class="col-md-10">
                <label>Description:</label>
                <textarea name="description"
                          formControlName="description"
                          (keyup)="smartTagModel.description = $event.currentTarget['value'];"
                          id="report-image-description" name="report-image-description" rows="3"
                          cols="50" [maxLength]="150"></textarea>
            </div>
        </div>
    </div>
</form>
